import React, { useMemo, useState } from "react";

function OptionNote({ html }) {
  if (!html) {
    return null;
  }

  return <span className="note" dangerouslySetInnerHTML={{ __html: html }} />;
}

function InfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="#868686"
      style={{ display: "block", width: "1.75rem", height: "1.75rem" }}
    >
      <path d="M256 56C145.72 56 56 145.72 56 256s89.72 200 200 200 200-89.72 200-200S366.28 56 256 56zm0 82a26 26 0 11-26 26 26 26 0 0126-26zm48 226h-88a16 16 0 010-32h28v-88h-16a16 16 0 010-32h32a16 16 0 0116 16v104h28a16 16 0 010 32z" />
    </svg>
  );
}
function Tooltip({ text }) {
    if (!text) {
        return null;
    }

    return (
        <div className="tooltip-toggle-radio">
            <button type="button" className="tooltip-toggle p-0 border-0 bg-transparent">
                <InfoIcon />
            </button>
            <div className="tooltip">
                <div
                    className="tooltip-inner text-white"
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            </div>
        </div>
    );
}

function SelectorOption({ option, index, selectedUrl, setSelectedUrl, inputName }) {
  const optionId = option.inputId || `${inputName}-${index}`;
  const isSelected = selectedUrl === option.url;

  return (
    <>
      <input
        type="radio"
        id={optionId}
        name={inputName}
        value={option.url}
        checked={isSelected}
        onChange={(event) => setSelectedUrl(event.target.value)}
        className="d-none"
        autoComplete="off"
      />
      <label htmlFor={optionId} className={option.labelClassName || undefined}>
        <span className={option.coverClassName || "radio-cover"}>
          <span
            className={option.titleWrapperClassName || "contact-tech-query-option-title d-inline-flex align-items-start position-relative"}
            style={option.titleWrapperStyle}
          >
                      <span className={option.titleClassName || "label font-weight-bold"} style={option.titleStyle}>{option.title}</span>
            <Tooltip
              text={option.popoverHtml}
            />
          </span>
          {option.subtitle ? <i className={option.subtitleClassName || "my-2"} style={option.subtitleStyle}>{option.subtitle}</i> : null}
          <OptionNote html={option.noteHtml} />
        </span>
      </label>
    </>
  );
}

function FaqListOption({ option, index, selectedUrl, setSelectedUrl }) {
  return (
    <li className="radio-style-button">
      <SelectorOption
        option={option}
        index={index}
        selectedUrl={selectedUrl}
        setSelectedUrl={setSelectedUrl}
              inputName="technicalQuestions"
      />
    </li>
  );
}

function FaqSubListOption({ option, index, selectedUrl, setSelectedUrl }) {
  const optionId = option.inputId || `technicalQuestions-${index}`;
  const isSelected = selectedUrl === option.url;

  return (
    <div className={option.columnClassName || "col-md-6 column mb-3"}>
      <div className={option.boxClassName || "btn-selector-box d-flex flex-column"}>
        <div className={option.rowClassName || "d-flex flex-nowrap align-items-center position-relative"}>
          <input
            type="radio"
            id={optionId}
            name="technicalQuestions"
            value={option.url}
            checked={isSelected}
            onChange={(event) => setSelectedUrl(event.target.value)}
            className="d-none"
            autoComplete="off"
          />
          <label htmlFor={optionId} className={option.labelClassName || "radio-lable small"}>
            <span
              className={option.titleWrapperClassName || "contact-tech-query-option-title d-inline-flex align-items-start position-relative"}
              style={option.titleWrapperStyle}
            >
              <span className={option.titleClassName || "radio-title"} style={option.titleStyle}>{option.title}</span>
            </span>
          </label>
            <Tooltip
                text={option.popoverHtml}
            />          
        </div>
        {option.subtitle ? <span className={option.subtitleClassName || "radio-subTitle"} style={option.subtitleStyle}>{option.subtitle}</span> : null}
      </div>
    </div>
  );
}

function renderOption(option, index, variant, selectedUrl, setSelectedUrl) {
  if (variant === "faq-sub-list") {
    return (
      <FaqSubListOption
        key={option.id || index}
        option={option}
        index={index}
        selectedUrl={selectedUrl}
        setSelectedUrl={setSelectedUrl}
      />
    );
  }

  return (
    <FaqListOption
      key={option.id || index}
      option={option}
      index={index}
      selectedUrl={selectedUrl}
      setSelectedUrl={setSelectedUrl}
    />
  );
}

export default function ContactTechQueryIsland({ config }) {
  const [selectedUrl, setSelectedUrl] = useState("");

  const groups = useMemo(() => {
    if (Array.isArray(config.groups) && config.groups.length > 0) {
      return config.groups;
    }

    return [
      {
        containerClassName: config.listContainerClassName || "",
        listClassName: config.listClassName || "",
        options: config.options || [],
      },
    ];
  }, [config]);

  const nextDisabled = selectedUrl.length === 0;

  const handleNextClick = (event) => {
    if (nextDisabled) {
      event.preventDefault();
    }
  };

  return (
    <section id="technicalQuery">
      <div className="row">
        <div className="col-md-8 offset-md-2 text-center my-4">
          <h1 className="text-bolder text-dark-blue">{config.title}</h1>
        </div>
      </div>
      <div className={config.bodyClassName} style={config.bodyStyle}>
        <div className="row clearfix">
          {groups.map((group, groupIndex) => (
            <div key={group.id || groupIndex} className={group.containerClassName || "d-flex flex-wrap"}>
              {group.listClassName ? (
                <ul className={group.listClassName}>
                  {group.options.map((option, optionIndex) =>
                    renderOption(option, optionIndex, config.variant, selectedUrl, setSelectedUrl),
                  )}
                </ul>
              ) : (
                group.options.map((option, optionIndex) =>
                  renderOption(option, optionIndex, config.variant, selectedUrl, setSelectedUrl),
                )
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-6 col-md-3 offset-md-3 column mb-3">
          <a href={config.backUrl} className={config.backClassName || "btn btn-wide btn-arrow-left btn-back"}>
            <span>{config.backLabel || "back"}</span>
          </a>
        </div>
        <div className="col-6 col-md-3 column mb-3">
          <a
            href={selectedUrl || config.nextFallbackUrl || "#"}
            className={`btn btn-wide btn-arrow-right btn-next${nextDisabled ? " disabled" : ""}`}
            aria-disabled={nextDisabled}
            tabIndex={nextDisabled ? -1 : undefined}
            onClick={handleNextClick}
          >
            <span>{config.nextLabel || "next"}</span>
          </a>
        </div>
      </div>
    </section>
  );
}
